export type GuidedFilterPostApplyStepIndex = 0 | 1 | 2;

export const GUIDED_FILTER_POST_APPLY_STEP_COUNT = 3;

export function formatRecordCountPopoverDescription(
  count: number,
  queryDone: boolean,
  error: string | null
): string {
  if (error?.trim()) {
    return 'The Record Count tile shows how many records match your current filter and date range. Refresh the dashboard or adjust your filter if the number does not update.';
  }
  if (!queryDone) {
    return 'Counting how many records match your filter…';
  }
  const formatted = count.toLocaleString();
  const noun = count === 1 ? 'record' : 'records';
  return `This filter returned ${formatted} ${noun}. The Record Count tile updates whenever you change your filter or date range.`;
}
